module.exports = __webpack_public_path__ + "img/slide_3.344fac68.webp";